module.exports = __webpack_public_path__ + "c6faa1d33a82c3cff7e23da8375ec448.jpg";